import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=4b8acc9c&scoped=true"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"
import style0 from "./FormInput.vue?vue&type=style&index=0&id=4b8acc9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8acc9c",
  null
  
)

export default component.exports